import { render } from "./PromptTest2Flow.vue?vue&type=template&id=40bef36c&scoped=true"
import script from "./PromptTest2Flow.vue?vue&type=script&lang=js"
export * from "./PromptTest2Flow.vue?vue&type=script&lang=js"

import "./PromptTest2Flow.vue?vue&type=style&index=0&id=40bef36c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bef36c"]])

export default __exports__